import { render, staticRenderFns } from "./staffFrom.vue?vue&type=template&id=16d863fc&scoped=true"
import script from "./staffFrom.vue?vue&type=script&lang=js"
export * from "./staffFrom.vue?vue&type=script&lang=js"
import style0 from "./staffFrom.vue?vue&type=style&index=0&id=16d863fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d863fc",
  null
  
)

export default component.exports